module.exports = __webpack_public_path__ + "img/maintop.0b31522.png";